import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Form as CustomForm } from '@repo-level/core-front';
import QRCode from 'react-qr-code';

import { FormGroup } from 'components/form/groups/FormGroup';
import { OfUnion } from 'types/common';
import { PaymentMethodContext } from '../providers';

import { ScCryptoBlock } from './styled';
import { ScQRCode } from 'components/form/QRCode/styled';
import { Button } from 'components/buttons';
import { useTheme } from 'hooks/theme';
import { useClipboardCopy } from 'hooks/useClipboardCopy';

export const FieldDepositCryptoAddress: FC<
  OfUnion<CustomForm.MethodField>[CustomForm.MethodFieldType.DepositCryptoAddress]
> = ({ label, fieldName, address }) => {
  const { t } = useTranslation(['glossary', 'deposits']);
  const { copyIcon: CopyIcon } = useTheme();
  const { copyActive, handleCopyCode } = useClipboardCopy(String(address));

  const { currency } = useContext(PaymentMethodContext);

  return (
    <FormGroup title={label || fieldName} marginBottom={8}>
      <ScCryptoBlock>
        <div className="details">{t('deposits:fields.crypto.text1')}</div>
        {!!address && (
          <ScQRCode>
            <QRCode value={address} size={90} />
          </ScQRCode>
        )}
        <div className="details-text">
          <span className="text-copy">
            {t('deposits:fields.crypto.text2', { currency })}
          </span>
          <br />
          <div className="wrapper">
            <span className="address">
              <span className="address-text">{address}</span>
            </span>
            <Button green wide xLarge onClick={handleCopyCode}>
              <div className="code-box">
                <span>{copyActive ? t('copied') : t('copyText')}</span>
                <CopyIcon />
              </div>
            </Button>
          </div>
        </div>
      </ScCryptoBlock>
    </FormGroup>
  );
};
